import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const corporateTestDriveLead = {
        isLoading: false,
        init() {
            $(document).on('click', '.corporate-test-drive-show-form', this, this.show);
            $(document).on('click', '#corporate-test-drive-request-send-btn', this, this.send);

			$(document).on('click', '#corporate-test-drive-request .radio-line .form-check', function(){
				$('#corporate-test-drive-request .radio-line .form-check').removeClass("selected");
				$('#corporate-test-drive-request .radio-line .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});

			$(document).on('change', '#tdr_model_id', this, this.showModalImage);
			$(document).on('change', '#tdr_auto_dealer_id', this, this.getModels);
        },
		getModels(event) {
			const _this = event.data;
    		let id = this.value;

			let name = $('#tdr_auto_dealer_id option:selected').text();
			let image = $('#tdr_auto_dealer_id option:selected').data('image');
			if (image != '') {
				$('#tdr-dealer-logo').attr('src', image);
			}

			$('#test-drive-model-image').html('');
			$('#test-drive-dealer-name').html(name);

			var values = 'id=' + id;
			$.ajax({
	            type: "GET",
	            url: baseURL + "/auto-dealer/get-models",
	            data: values,
	            success: function(models) {
					$('#tdr_model_id').find('option:not(:first)').remove();

					for(var i in models) {
						if (models[i].available_test_drive == 1) {
							$('#tdr_model_id').append('<option value="'+models[i].id+'" data-image="'+baseURL+'/uploads/'+models[i].thumbnail+'">'+models[i].name+'</option>');
						}
					}
	            }
	        });
		},
		showModalImage(event) {
			const _this = event.data;

			let image = $('#tdr_model_id option:selected').data('image');
			if (image != '') {
				$('#test-drive-model-image').html('<img src="'+image+'" />');
			} else {
				$('#test-drive-model-image').html('');
			}
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let dealerId = 1*$(this).data('dealer-id');
			let modelId = 1*$(this).data('model-id');

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#corporate-test-drive-request').find('.form-control').removeClass('is-invalid');
			$('#corporate-test-drive-request').find('.form-check-input').removeClass('is-invalid');
			$('#tdr-notifications').html('');

			if ($('#tdr_auto_dealer_id option:selected').val() == '' && dealerId == 0) {
				$('#tdr_auto_dealer_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#tdr_model_id option:selected').val() == '' && modelId == 0) {
				$('#tdr_model_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#salutation option:selected').val() == '') {
				$('#salutation').addClass('is-invalid');
				errors = true;
			}
			if ($('#first_name').val() == '') {
				$('#first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#last_name').val() == '') {
				$('#last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#locality option:selected').val() == '') {
				$('#locality').addClass('is-invalid');
				errors = true;
			}
			if (!$('#test-drive-terms-and-condition').is(":checked")) {
				$('#test-drive-terms-and-condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#tdr-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				document.getElementById('test-drive-request').scrollTop = 0;
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'auto_dealer_id=' + (dealerId > 0 ? dealerId : $('#tdr_auto_dealer_id option:selected').val());
			values += '&model_id=' + (modelId > 0 ? modelId : $('#tdr_model_id option:selected').val());
			values += '&salutation=' + $('#salutation option:selected').val();
			values += '&first_name=' + $('#first_name').val();
			values += '&last_name=' + $('#last_name').val();
			values += '&date_of_birth=' + $('#date_of_birth').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&locality=' + $('#locality option:selected').val();
			values += '&newsletter=' + ($('.test-drive-newsletter:checked').val()?$('.test-drive-newsletter:checked').val():0);
			values += '&_token=' + $('#_token_tdr').val();
			$.ajax({
	            type: "POST",
	            url: corporateTestDriveRequestRoutePost,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#tdr-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

					if (response.status == 1) {
						$('#corporate-test-drive-request').modal('hide');
						$('#corporate-test-drive-request').on('hidden.bs.modal', function() {
							$('#corporate-test-drive-request-container').html('');
						});

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: formSuccessMessage
						});

						if (cookies_advertisement == 1) {
							gtag('event', 'conversion', {'send_to': 'AW-732195211/jAXbCIXv8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							fbq('track', 'Lead');
						}

						return false;
					}

					$('#tdr-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		show(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').removeClass('fa-steering-wheel').addClass('fa-spinner fa-spin');

			var values = 'dealer_id=' + $(this).data('dealer-id');
			values += '&model_id=' + $(this).data('model-id');
			$.ajax({
	            type: "GET",
	            url: corporateTestDriveRequestRoute,
	            data: values,
	            success: function(response) {
					//check if full menu is open, if is close it
					// if ($('.meniu-desktop').hasClass('open')) {
					// 	$('.meniu-desktop').removeClass('open');
					// }
					$(".header").removeClass('mobile-meniu-open');

					$('#corporate-test-drive-request-container').html(response);
					$('#corporate-test-drive-request').modal('show');

					$('#corporate-test-drive-request').on('shown.bs.modal', function (e) {
						if ($(document).width() > 1025) {
							equalCols('.test-drive-eq-height');
						}
					});

					$('.datepicker').datepicker({
						format: 'dd.mm.yyyy',
						language: 'ro'
					}).attr('readonly','readonly');

					_this.isLoading = false;
					$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-steering-wheel');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-steering-wheel');
                },
	        });
		}
    };

    if ($('.corporate-test-drive-show-form').length) {
        corporateTestDriveLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/corporate-test-drive-lead.js